<template>
  <validation-observer ref="simpleRules">
    <b-form autocomplete="off">
      <h5 class="text-primary">
        {{ $t('Box Properties') }}
      </h5>
      <b-row>
        <!-- Page Select-->
        <b-col md="6">
          <b-form-group
            :label="$t('Page')"
            label-for="mc-parent"
          >
            <validation-provider
              #default="{ errors }"
              name="Page"
              rules="required"
            >
              <v-select
                id="vue-select-page"
                v-model="item.pageId"
                :options="optionPage"
                :reduce="page => page.id"
                label="title"
                :clearable="false"
                :state="errors.length > 0 ? false:null"
                :placeholder="$t('Select page...')"
                @input="getBoxOptions(true)"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Box Select-->
        <b-col md="6">
          <b-form-group
            :label="$t('Box')"
            label-for="mc-box"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Box')"
              rules="required"
            >
              <v-select
                id="vue-select"
                v-model="item.boxId"
                :options="optionBox"
                :reduce="box => box.id"
                label="boxTitle"
                :clearable="false"
                :state="errors.length > 0 ? false:null"
                :placeholder="$t('Select box...')"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            :label="$t('File Name')"
            label-for="fileName"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('File Name')"
              rules="required"
            >
              <b-form-input
                ref="fileName"
                v-model="item.fileName"
                :state="errors.length > 0 ? false:null"
                :placeholder="$t('File Name')"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>

        <b-col>
          <!-- Period Type -->
          <b-form-group
            :label="$t('Period Type')"
            label-for="mc-periodType"
          >
            <v-select
              id="vue-select-periodType"
              v-model="item.periodType"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionPeriodType"
              :clearable="false"
              :placeholder="$t('period type')"
            />
          </b-form-group>
        </b-col>

        <template v-if="item.periodType!=='YTD'">

          <!-- Last N -->
          <b-col>
            <b-form-group
              :label="`${$t('Last N')} ${item.periodType}`"
              label-for="lastNWave"
            >
              <validation-provider
                #default="{ errors }"
                :name="`${$t('Last N')} ${item.periodType}`"
                rules="required|between:1,12"
              >
                <b-form-input
                  ref="lastNWave"
                  v-model="item.lastNWave"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('0-12')"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col v-if="item.periodType==='month'">
            <!-- Rolling -->
            <b-form-group
              :label="$t('Rolling')"
              label-for="mc-rolling"
            >
              <v-select
                id="vue-select-rolling"
                v-model="item.rolling"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionRolling"
                :clearable="false"
                :placeholder="$t('No rolling')"
              />
            </b-form-group>
          </b-col>

          <!-- skipCurrent -->
          <b-col>
            <b-form-group
              :label="$t(`Skip current ${item.periodType}`)"
              label-for="skipCurrent"
            >
              <b-form-checkbox
                id="skipCurrent"
                v-model="item.skipCurrent"
                class="mt-1"
                name="skipCurrent"
                switch
              >
                <span v-if="item.skipCurrent">{{ $t('Yes') }}</span>
                <span v-if="!item.skipCurrent">{{ $t('No') }}</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>

        </template>

      </b-row>

      <h5 class="text-primary mt-2">
        {{ $t('Delivery Properties') }}
      </h5>

      <b-row>

        <!-- Start Date Time -->
        <b-col>
          <b-form-group
            :label="$t('Start Date & Time')"
            label-for="mc-start-date-time"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Start Date & Time')"
              rules="required"
            >
              <flat-pickr
                v-model="item.startDateTime"
                class="form-control"
                :state="errors.length > 0 ? false:null"
                :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
                :placeholder="$t('Select...')"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Frequency Value -->
        <b-col>
          <b-form-group
            :label="$t('Frequency Value')"
            label-for="frequencyValue"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Frequency Value')"
              rules="required|between:1,99"
            >
              <b-form-input
                v-model="item.frequencyValue"
                :state="errors.length > 0 ? false:null"
                :placeholder="$t('Frequency Value (1-99)')"
              />
              <small class="text-danger">{{ $t(errors[0]) }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Frequency Unit -->
        <b-col>
          <b-form-group
            :label="$t('Frequency Unit')"
            label-for="mc-frequencyUnit"
          >
            <v-select
              id="vue-select-frequencyUnit"
              v-model="item.frequencyUnit"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionFrequencyUnit"
              :clearable="false"
              :placeholder="$t('Select')"
            />
          </b-form-group>
        </b-col>

      </b-row>

      <h5 class="text-primary mt-2">
        {{ $t('FTP Properties') }}
      </h5>
      <b-row>
        <!-- Ftp Address -->
        <b-col>
          <b-form-group
            :label="$t('Ftp Address')"
            label-for="ftpAddress"
          >
            <b-form-input
              v-model="item.ftpAddress"
              :placeholder="$t('Ftp Address')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <!-- Ftp User Name -->
        <b-col>
          <b-form-group
            :label="$t('Ftp User Name')"
            label-for="ftpUserName"
          >
            <b-form-input
              v-model="item.ftpUserName"
              :placeholder="$t('User name')"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <!-- Ftp Password -->
        <b-col>
          <b-form-group
            :label="$t('Ftp Password')"
            label-for="ftpPassword"
          >
            <b-form-input
              v-model="item.ftpPassword"
              type="password"
              :placeholder="$t('Password')"
              autocomplete="new-password"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <h5 class="text-primary mt-2">
        {{ $t('Email Properties') }}
      </h5>
      <!-- Email Address List -->
      <b-row>
        <b-col>
          <b-form-group
            :label="$t('Email Address List')"
            label-for="mc-emailAddressList"
          >
            <b-form-textarea
              v-model="item.emailAddressList"
              :placeholder="$t('Email Address List... (separate by ;)')"
            />

          </b-form-group>
        </b-col>
      </b-row>

      <!-- Email Subject -->
      <b-row>
        <b-col>
          <b-form-group
            :label="$t('Email Subject')"
            label-for="emailSubject"
          >
            <b-form-input
              v-model="item.emailSubject"
              :placeholder="$t('Email Subject')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Email Body -->
      <b-row>
        <b-col>
          <b-form-group
            :label="$t('Email Body')"
            label-for="mc-emailBody"
          >
            <b-form-textarea
              v-model="item.emailBody"
              :placeholder="$t('Email Body')"
            />

          </b-form-group>
        </b-col>
      </b-row>

    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

import {
  BFormGroup, BFormInput, BForm, BRow, BCol, BFormTextarea, BFormCheckbox,

} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    BFormCheckbox,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      defaultItem: {
        boxId: null,
        fileName: null,
        pageId: null,
        lastNWave: 1,
        skipCurrent: true,
        fromWave: null,
        toWave: null,
        rolling: 1,
        startdatetime: new Date(),
        frequencyValue: 1,
        frequencyUnit: 'day',
        ftpAddress: null,
        ftpUserName: null,
        ftpPassword: null,
        emailAddressList: null,
        emailSubject: null,
        emailBody: null,
        periodType: 'month',
      },
      optionPeriod: this.$store.state.globals.periodList,
      optionRolling: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      optionPeriodType: ['month', 'quarter', 'YTD'],
      optionFrequencyUnit: ['month', 'week', 'day', 'hour'],
      optionPage: [],
      optionBox: [],
      required,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  async created() {
    await this.getPageOptions()
  },
  methods: {
    getPageOptions() {
      const menu = this.$store.state.verticalMenu.menuLinks
      this.optionPage = []
      menu.forEach(item => {
        if (!item.children.length) {
          this.optionPage.push({ id: item.id, title: this.$t(item.title) })
        } else {
          item.children.forEach(c => {
            if (!c.children.length) {
              this.optionPage.push({ id: c.id, title: `${this.$t(item.title)}/${this.$t(c.title)}` })
            } else {
              c.children.forEach(cc => {
                this.optionPage.push({ id: cc.id, title: `${this.$t(item.title)}/${this.$t(c.title)}/${this.$t(cc.title)}` })
              })
            }
          })
        }
      })
    },
    getBoxOptions(clearSelectedBox = false) {
      if (clearSelectedBox) {
        this.item.boxId = null
      }
      useJwt.axiosIns.get(`box/${this.item.pageId}`).then(response => {
        this.optionBox = response.data
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const postItem = JSON.parse(JSON.stringify(this.item))

          if (!postItem.fromWave || postItem.lastNWave > 0) {
            postItem.fromWave = 0
          }
          if (!postItem.toWave || postItem.lastNWave > 0) {
            postItem.toWave = 0
          }

          if (this.item.id) {
            useJwt.axiosIns.patch('scheduledbox', postItem)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            useJwt.axiosIns.post('scheduledbox', postItem)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        }
      })
    },
    run() {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Started',
          icon: 'CoffeeIcon',
          variant: 'success',
          text: 'Process started...',
        },
      })

      useJwt.axiosIns.get(`scheduledbox/forcerun/${this.item.id}`)
        .then(response => {
          if (response.data === 'OK') {
            this.$emit('run_success')
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
